module.exports = __webpack_public_path__ + "static/media/card-bg.41193970.png";